// src/components/trackinginfo/api/trackingInfoRepsApi.js
// ============================================================================
// BLOCK TI.API.REPS.0 — Tracking Info reps dropdown API
// ============================================================================
import axios from '../../../axiosClient.js';

export default async function fetchTrackingReps({ company = 'tzi' } = {}) {
  const res = await axios.get('/api/trackinginfo/reps', {
    params: { company },
  });

  // Expect: { ok:true, data:[{no,name,email}] }
  return res.data;
}
